var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isFailure == false)?_c('span',{class:_vm.className},[_vm._v(_vm._s(_vm.showName))]):_vm._e(),(_vm.isFailure == true)?_c('span',{class:_vm.className,staticStyle:{"color":"#5babfb","cursor":"pointer"},on:{"click":_vm.Failure}},[_vm._v(_vm._s(_vm.showName))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }